import type { builderComponentSdkFactoryArgs, ComponentSdkFactory, componentSdkFactoryArgs } from '@wix/thunderbolt-platform-types'
import { BUILDER_COMPONENT_SDK_FACTORY_PARAMS, SERVICES_LOADER } from './moduleNames'
import type { IServices } from './servicesLoader'

export type IBuilderComponentSdkFactoryParams = {
	getBuilderComponentSdkFactoryParams(sdkFactoryParams: componentSdkFactoryArgs, baseApiFactory?: ComponentSdkFactory | null): builderComponentSdkFactoryArgs
}

const BuilderComponentSdkFactoryParams = ({ getService }: IServices): IBuilderComponentSdkFactoryParams => {
	return {
		getBuilderComponentSdkFactoryParams: (sdkFactoryParams: componentSdkFactoryArgs, baseApiFactory?: ComponentSdkFactory | null) => ({
			getProps: () => sdkFactoryParams.props,
			setProps: sdkFactoryParams.NCMSetProps,
			getService,
			legacyApi: sdkFactoryParams,
			baseApi: baseApiFactory ? baseApiFactory(sdkFactoryParams) : {},
		}),
	}
}

export default {
	factory: BuilderComponentSdkFactoryParams,
	deps: [SERVICES_LOADER],
	name: BUILDER_COMPONENT_SDK_FACTORY_PARAMS,
}
